/* global __AUTH0_CLIENT_ID__ */
/* global __AUTH0_DOMAIN__ */
/* global __AUTH0_ZENDESK_CLIENT_ID__ */
/* global __BLUEHQ_ENV_SHORT__ */

import { WebAuth } from 'auth0-js';
import AuthActions from '../actions/AuthActions';

export const AUTH0_CLIENT_ID = __AUTH0_CLIENT_ID__;
export const AUTH0_DOMAIN = __AUTH0_DOMAIN__;
export const AUTH0_ZENDESK_CLIENT_ID = __AUTH0_ZENDESK_CLIENT_ID__;

export class Auth {
  constructor(options = {}) {
    this.clientID = AUTH0_CLIENT_ID;
    this.domain = AUTH0_DOMAIN;

    this.auth0 = new WebAuth({
      clientID: this.clientID,
      domain: this.domain,
      redirect: true,
      redirectUri: `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}/authcallback`,
      audience: `https://${this.domain}/userinfo`,
      scope: 'openid email profile',
      responseType: 'token id_token',
      ...options,
    });

    this.login = this.login.bind(this);
    this.logout = this.logout.bind(this);
    this.getUserInfo = this.getUserInfo.bind(this);
  }

  login() {
    this.auth0.authorize();
  }

  logout() {
    window.location = `https://${this.domain}/v2/logout?returnTo=${window.location.origin}`;
  }

  // Just a pass-through to the client call
  getUserInfo(...args) {
    return this.auth0.client.userInfo(...args);
  }

  handleAuthentication() {
    this.auth0.parseHash((authErr, authResult) => {
      if (authResult && authResult.accessToken && authResult.idToken) {
        AuthActions.authenticated(authResult);
      } else if (authErr) {
        AuthActions.authenticationFailed(authErr);
      }
    });
  }
}

const auth = new Auth();

export default auth;
